
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"68","height":"67"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#71d3b9","d":"M33.937 12.44l17.464 8.438 4.314 18.96-12.086 15.204H24.246L12.16 39.838l4.313-18.96z"}}),_c('path',{attrs:{"fill":"#0a294a","d":"M24.737 18.135l16-.08 10.038 12.5-3.482 15.668-14.381 7.037-14.45-6.892-3.639-15.632z"}}),_c('g',[_c('path',{attrs:{"fill":"#fff","d":"M39.507 30.152c1.513 0 2.808.506 3.882 1.517C44.463 32.68 45 33.898 45 35.324c0 1.425-.537 2.647-1.611 3.667-1.074 1.019-2.369 1.529-3.882 1.529h-4.411v-4.749l1.426 1.318c.229.215.493.323.793.323.281 0 .537-.108.765-.323a.954.954 0 00.317-.721.955.955 0 00-.317-.721l-3.3-3.108c-.195-.182-.45-.277-.767-.286a1.066 1.066 0 00-.792.286l-3.301 3.108a.955.955 0 00-.317.72c0 .283.105.523.317.722.228.215.492.323.792.323.281 0 .537-.108.766-.323l1.426-1.318v4.749h-5.493c-1.215 0-2.254-.406-3.117-1.218-.863-.812-1.294-1.79-1.294-2.934 0-.961.308-1.81.924-2.548.617-.738 1.408-1.223 2.377-1.455v-.15c0-1.723.647-3.19 1.941-4.4C29.537 26.605 31.091 26 32.904 26c1.409 0 2.681.385 3.817 1.156 1.135.771 1.931 1.778 2.39 3.021z"}})])])
          )
        }
      }
    